import * as types from './actionTypes';

const initalState = {
  paymentStep: 1,

  businessData: {},
  userPaymentDetails: {},
  paymentStatus: false,
  createPaymentLoader: false,
  verifyStripeOnboardingStatus: false,
  verifySlugStatus: true,
  onboardingStatus: false,
  paymentSlug: '',
  KPIData: {},
};

export const paymentReducer = (state = initalState, action) => {
  const { type } = action;
  switch (type) {
    case types.PAYMENT_STEP:
      return {
        ...state,
        paymentStep: action.payload,
      };

    case types.SET_VERIFY_SLUG_STATUS:
      return {
        ...state,
        verifySlugStatus: action.payload,
      };
    case types.SET_BUSINESS_DATA:
      return {
        ...state,
        businessData: action.payload,
      };
    case types.SET_USER_PAYMENT_DETAILS:
      return {
        ...state,
        userPaymentDetails: action.payload,
      };
    case types.CREATE_PAYMENT_LOADER:
      return {
        ...state,
        createPaymentLoader: action.payload,
      };
    case types.SET_PAYMENT_VERIFY_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };
    case types.COMPLETE_STRIPE_ONBOARDING_SUCCESS:
      return {
        ...state,
        stripeOnboardingStatus: action.payload,
      };
    case types.SET_VERIFY_STRIPE_ONBOARDING_STATUS:
      return {
        ...state,
        verifyStripeOnboardingStatus: action.payload,
      };
    case types.SET_PAYMENT_HISTORY_LIST:
      return {
        ...state,
        paymentHistoryList: action.payload,
      };
    case types.SET_KPI_DATA:
      return {
        ...state,
        KPIData: action.payload,
      };
    case types.SET_PAYMENT_SLUG:
      return {
        ...state,
        paymentSlug: action.payload,
      };
    default:
      return state;
  }
};
